import Spring from "../../components/Spring";
import styled, { css } from "styled-components";
import { aspectRatio as ar } from "../../../common/parameters";
import { staffLines } from "../../../common/styles";

export const StyledSpring = styled(Spring)`
    margin-top: 50px;
    background-color: ${p => p.theme.c.snow};
    p {
        line-height: 28px;
        margin-top: 6px;
    }

    ${p => p.theme.xs(css`
        margin-top: 20px;
    `)}
`;

export const Container = styled.div`
    box-sizing: border-box;
    max-width: 770px;
    margin: auto;
    padding: 25px 25px 25px 26px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    margin-top: 50px;
    ${p => p.theme.md.min(css`
        padding-bottom: 38px;
    `)}
    ${p => p.theme.sm.only(css`
        width: 600px;
        padding: 20px;
    `)}
    ${p => p.theme.xs(css`
        margin-left: -16px;
        margin-right: -16px;
        height: 58.95vw;
        padding: 3.8%;
    `)}
`;

export const Screen = styled.div`
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    ${p => p.theme.md.min(css`
        width: 720px;
        height: ${720 * ar.height / ar.width}px;
    `)}
    ${p => p.theme.sm.only(css`
        width: 560px;
        height: ${560 * ar.height / ar.width}px;
    `)}
    ${p => p.theme.xs(css`
        height: 100%;
    `)}
`;

export const CreatePadding = styled.div`
    padding: 40px 70px;
    ${p => p.theme.md.only(css`
        padding: 20px 30px;
    `)}
    ${p => p.theme.xs(css`
        padding: 20px 0;
    `)}

    ${p => p.theme.sm.max(css`
        p {
            margin-bottom: 0;
        }
    `)}
`;

export const CreateFlex = styled.div`
    display: flex;
    ${p => p.theme.sm.max(css`
        flex-direction: column-reverse;
    `)}
`;

export const CreateLeft = styled.div`
    ${p => p.theme.md.min(css`
        width: 425px;
        padding-right: 50px;
    `)}
    box-sizing: border-box;

    h4:nth-of-type(2) {
        ${p => p.theme.lg(css`
            margin-top: 75px;
        `)}
        ${p => p.theme.md.only(css`
            margin-top: 0;
        `)}
    }
`;

export const CreateRight = styled.div`
    flex: 1;
`;

export const H4 = styled.h4`
    font-size: 24px;
    color: ${p => p.theme.c.info};
    font-variant: small-caps;
    font-weight: 400;
    margin-bottom: 0;
    &.NoMarginTop {
        ${p => p.theme.md.min(css`
            margin-top: -20px;
        `)}
    }
`;

export const StyledHello = styled.div`
    margin-bottom: 50px;
    ${p => p.theme.sm.only(css`
        padding: 0 20px;
    `)}
`;

export const Ribbon = styled.div`
    background-color: ${p => p.theme.c.info};
    height: 25px;
`;

export const EditHello = styled.div`
    ${p => p.theme.sm.only(css`
        padding: 0 50px;
    `)}
`;

export const TippCard = styled.div`
    background-color: ${p => p.theme.c.cardBackground};
    border-radius: 16px;
    padding: 1px 16px 1px 0;
    line-height: 1.5;
    margin: 30px 70px 60px;
    ${p => p.theme.md.only(css`
        margin: 30px 20px;
    `)}
    ${p => p.theme.xs(css`
        margin: 24px 0 32px;
    `)}
`;

export const TippContainer = styled.div`
    ${staffLines};
    font-size: 18px;
`;

// 657 x 415
// x,y = 24
// w,h = 611 x 342

export const StyledThemes = styled.div`
    display: flex;
    ${p => p.theme.sm.max(css`
        flex-direction: column;
    `)}
    justify-content: center;
    ${p => p.theme.xs(css`
        margin: 0 -16px;
    `)}
    margin-bottom: 32px;

`;

const width = 340;

export const Theme = styled.div`
    width: ${width}px;
    height: ${width * (415 / 657)}px;
    background-size: 100% 100%;
    margin: 20px;
    position: relative;
    ${p => p.theme.sm.max(css`
        margin: 20px auto 0;
    `)}
    ${p => p.theme.md.only(css`
        width: ${width * 0.8}px;
        height: ${width * 0.8 * (415 / 657)}px;
    `)}
    margin-bottom: 0;
    ${p => p.theme.xs(css`
        width: 320px;
        height: ${320 * (415 / 657)}px;
        margin: 12px auto 0;
    `)}
`;

export const ThemeImage = styled.img`
    margin: ${23.4 * (width / 657)}px;
    width: ${width * (611 / 657)}px;
    ${p => p.theme.md.only(css`
        width: ${width * 0.8 * (611 / 657)}px;
        margin: ${23.4 * (width * 0.8 / 657)}px;
    `)}
    ${p => p.theme.xs(css`
        margin: ${23.4 * (320 / 657)}px;
        width: ${320 * (611 / 657)}px;
    `)}
`;


export const NewMarker = styled.div`
    background-color: ${p => p.theme.c.play};
    color: ${p => p.theme.c.whiteOnActive};
    font-size: 20px;
    position: absolute;
    top: -16px;
    right: -16px;
    padding: 8px;
    min-width: 30px;
    text-align: center;
`;